/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prop_No_MilestoneInputs */

const en_prop_no_milestone = /** @type {(inputs: Prop_No_MilestoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No milestone`)
};

const de_prop_no_milestone = /** @type {(inputs: Prop_No_MilestoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Meilenstein`)
};

/**
* | output |
* | --- |
* | "No milestone" |
*
* @param {Prop_No_MilestoneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const prop_no_milestone = /** @type {((inputs?: Prop_No_MilestoneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prop_No_MilestoneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_prop_no_milestone(inputs)
	return en_prop_no_milestone(inputs)
});